import { render, staticRenderFns } from "./SettingsGlobalConfig.vue?vue&type=template&id=491274d9&"
import script from "./SettingsGlobalConfig.vue?vue&type=script&lang=js&"
export * from "./SettingsGlobalConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports